import { render, staticRenderFns } from "./ClassdetailsList.vue?vue&type=template&id=3dfe8628&scoped=true"
import script from "./ClassdetailsList.vue?vue&type=script&lang=js"
export * from "./ClassdetailsList.vue?vue&type=script&lang=js"
import style0 from "./ClassdetailsList.vue?vue&type=style&index=0&id=3dfe8628&prod&lang=less&scoped=true"
import style1 from "./ClassdetailsList.vue?vue&type=style&index=1&id=3dfe8628&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe8628",
  null
  
)

export default component.exports